define.alias("shared/components/shared/youtube-tos-modal", "media/components/shared/youtube-tos-modal");